// extracted by mini-css-extract-plugin
export default {"white_label_item":"CustomDomain_white_label_item__at-f1","acc_edit__wrapper":"CustomDomain_acc_edit__wrapper__ypKyO","container":"CustomDomain_container__rjVr3"};